module.exports = __webpack_public_path__ + "img/emptyimg.8a1e6e9e.png";